import { MessageCircle, Phone, Mail } from "lucide-react";

const btnClass =
  "w-12 h-12 rounded-full bg-zinc-950 text-white flex items-center justify-center shadow-lg hover:bg-zinc-700 transition-colors duration-300";

export default function FloatingContact() {
  return (
    <div data-testid="floating-contact" className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        data-testid="floating-whatsapp-btn"
        href="https://wa.me/918850727221?text=Hi%20Saurabh%20Decor%20Creations%2C%20I%20would%20like%20to%20discuss%20a%20project."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className={btnClass}
      >
        <MessageCircle className="w-5 h-5" strokeWidth={1.5} />
      </a>
      <a
        data-testid="floating-call-btn"
        href="tel:+918850727221"
        aria-label="Call Now"
        className={btnClass}
      >
        <Phone className="w-5 h-5" strokeWidth={1.5} />
      </a>
      <a
        data-testid="floating-email-btn"
        href="mailto:srbh9549@gmail.com"
        aria-label="Email Us"
        className={btnClass}
      >
        <Mail className="w-5 h-5" strokeWidth={1.5} />
      </a>
    </div>
  );
}
